import Model from './BaseModel';
import AdminUser from './AdminUser';

export default class BonusBet extends Model {
	resourceName() {
		return 'bonuses';
	}

	fields() {
		return ['balance', 'amount', 'created_at', 'expired_at', 'note', 'type'];
	}

	relationships() {
		return {
			admin_user: new AdminUser()
		};
	}

	saveBonus(data) {
		return this.makePersistRequest({
			url: this.resourceUrl(),
			method: 'POST',
			data
		});
	}

	expireBonus() {
		return this.makePersistRequest({
			url: `${this.baseUrl()}/${this.resourceName()}/${this.id}`,
			method: 'PATCH',
			data: {
				is_expired: true
			}
		});
	}
}
